import { useEffect, useState } from "react";

interface UseAnimatedMountOptions {
    duration?: number;
    onUnmount?: () => void;
}

/**
 * Hook to handle animated mount/unmount of a component
 * @param shouldShow - Condition to determine if the component should be visible
 * @param options - Configuration options
 * @returns { isMounted, isVisible } - States to control rendering and animation
 */
const useAnimatedMount = (
    shouldShow: boolean,
    { duration = 500, onUnmount }: UseAnimatedMountOptions = {},
) => {
    const [isMounted, setIsMounted] = useState(shouldShow);
    const [isVisible, setIsVisible] = useState(shouldShow);

    useEffect(() => {
        if (shouldShow) {
            // Montage immédiat
            setIsMounted(true);

            // Animation d'entrée après le montage
            const timer = setTimeout(() => setIsVisible(true), 10);

            return () => clearTimeout(timer);
        }

        // Animation de sortie
        setIsVisible(false);

        // Démontage après l'animation
        const timer = setTimeout(() => {
            setIsMounted(false);
            onUnmount?.();
        }, duration);

        return () => clearTimeout(timer);
    }, [shouldShow, duration, onUnmount]);

    return { isMounted, isVisible };
};

export default useAnimatedMount;
